<ng-container ng-switch-case [ngSwitch]="(labelingReviewService.reviewFetchType$ | async)">
    No annotations 
    <ng-container *ngSwitchCase="ReviewFetchType.RECORDS_TO_REVIEW">to review</ng-container>
    <ng-container *ngSwitchCase="ReviewFetchType.REVIEWED_RECORDS">validated</ng-container>
</ng-container>
